import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { Shipment } from '../../../models/shipment/shipment';
import { FormControl } from '@angular/forms';
import { InvoiceProxyService } from '../../../proxies/order/invoice.proxy.service';
import { Invoice } from '../../../models/invoice/invoice';

@Component({
  selector: 'app-shipment-detail-modal',
  templateUrl: './shipment-detail-modal.component.html',
  styleUrl: './shipment-detail-modal.component.scss',
})
export class ShipmentDetailModalComponent extends BaseModalComponent<Shipment | null> implements OnInit {
  @Input() shipment: Shipment | null = null;
  @Input() purchaseOrderReference: string | null = null;
  createDate = new FormControl({
    value: new Date(),
    disabled: true,
  });
  estimatedArrivalDate = new FormControl({
    value: new Date(),
    disabled: true,
  });
  purchaseOrderInvoices: Invoice[] = [];
  shipmentInvoices: Invoice[] = [];

  constructor(
    private injector: Injector,
    private invoiceservice: InvoiceProxyService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.estimatedArrivalDate.setValue(new Date(this.shipment!.estimatedArrivalDate!) as Date);
    this.createDate.setValue(new Date(this.shipment!.createdDate!) as Date);
    this.getInvoices();
  }

  onClose(): void {
    this.close({ action: 'close', data: null });
  }

  formatDate(date: Date | string): string {
    if (!date) return '';

    const parsedDate = typeof date === 'string' ? new Date(date) : date;

    if (isNaN(parsedDate.getTime())) return ''; // Maneja fechas inválidas

    return `${parsedDate.getFullYear()}-${String(parsedDate.getMonth() + 1).padStart(2, '0')}-${String(parsedDate.getDate()).padStart(2, '0')}`;
  }

  getInvoices() {
    this.invoiceservice.searchInvoice({ purchaseOrderReference: this.purchaseOrderReference ?? '' }, 1, 9999, false).subscribe({
      next: (response) => {
        if (response.success && response.data) {
          this.purchaseOrderInvoices = response.data.items;
          this.purchaseOrderInvoices.forEach((invoice) => {
            if (this.shipment?.invoiceReferences.includes(invoice.id!)) {
              this.shipmentInvoices.push(invoice);
            }
          });
        }
      },
      error: (error) => {
        console.log('🚀 ~ ShipmentDetailModalComponent ~ getInvoices ~ error:', error);
      },
    });
  }
}
